<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalHelpIndex]="modalHelpIndex"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="createEditDataArea()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalDraggable]=false>

    <res-name-description [customClassRow]="customClassRow" [name]=" this.nameDescriptionComponent.name"
        [description]=" this.nameDescriptionComponent.description" [validateNameRequest]="validateNameRequest"
        [validateName]="true" [onlyOnSave]="true" [automationId]="modalAutomationId">
    </res-name-description>

    <res-connectors-and-tree class="modal-fill" [disableConnGrid]="isEditDataArea" [automationId]="modalAutomationId"
        (onCONChange)="onConnectorAndTreeChange()"></res-connectors-and-tree>
</res-base-modal>